import React from 'react';
import {
  Icon, InputAdornment, TextField,
} from '@material-ui/core';
import ReactInputMask from 'react-input-mask';
import clsx from 'clsx';
import { propTypes, defaultProps } from './PropTypes';
import rules from './Rules';
import useStyle from '../../../../style';

function InputCpf({
  handleChange, handleBlur, errors, value, typeInput, disabled,
}) {
  const classes = useStyle();
  return (
    <ReactInputMask
      mask="999.999.999-99"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      maskPlaceholder={null}
    >
      <TextField
        fullWidth
        name="cpf"
        label="CPF"
        variant={typeInput}
        color="primary"
        helperText={errors}
        error={!!errors}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon className={clsx(['fas', 'fa-id-card', classes.inputIcon])} />
            </InputAdornment>
          ),
        }}
      />
    </ReactInputMask>
  );
}

InputCpf.propTypes = propTypes;
InputCpf.defaultProps = defaultProps;
InputCpf.rules = rules;

export default InputCpf;
